import { findNodeById } from "../NodeUtils";
import { createPlaceholderElement } from "../pageNodeEngine";

export function moveNodeOnDrop(page, sourceId, targetId, position = "before") {
  if (sourceId === targetId) return page;

  const newPage = JSON.parse(JSON.stringify(page));
  const src = findNodeById(newPage, sourceId);
  const tgt = findNodeById(newPage, targetId);

  if (!src || !tgt) return page;

  if (src.level === "element" && tgt.level === "element") {
    moveElementAcrossCards(newPage, src, tgt);
  }

  if (src.level === "card" && tgt.level === "card") {
    moveCardAcrossContainers(newPage, src, tgt);
  }

  if (src.level === "container" && tgt.level === "container") {
    moveContainerAcrossSections(newPage, src, tgt);
  }

  if (src.level === "section" && tgt.level === "section") {
    reorder(newPage.sections, src.path.sectionIndex, tgt.path.sectionIndex, position);
  }

  return newPage;
}
function reorder(arr, from, to, position = "before") {
  const item = arr.splice(from, 1)[0];
  const insertIndex = position === "after" ? to + 1 : to;
  arr.splice(insertIndex, 0, item);
}
function moveElementAcrossCards(page, src, tgt) {
  const srcCard = page.sections[src.path.sectionIndex]
    .contents[src.path.containerIndex]
    .cards[src.path.cardIndex];

  const tgtCard = page.sections[tgt.path.sectionIndex]
    .contents[tgt.path.containerIndex]
    .cards[tgt.path.cardIndex];

  const [movingElement] = srcCard.elements.splice(src.path.elementIndex, 1);

  tgtCard.elements.splice(tgt.path.elementIndex, 0, movingElement);

  // Ensure srcCard doesn't become empty
  if (srcCard.elements.length === 0) {
    srcCard.elements.push(createPlaceholderElement());
  }
}

function moveCardAcrossContainers(page, src, tgt) {
  const srcArr = page.sections[src.path.sectionIndex]
    .contents[src.path.containerIndex].cards;

  const tgtArr = page.sections[tgt.path.sectionIndex]
    .contents[tgt.path.containerIndex].cards;

  const [movingCard] = srcArr.splice(src.path.cardIndex, 1);

  tgtArr.splice(tgt.path.cardIndex, 0, movingCard);
}

function moveContainerAcrossSections(page, src, tgt) {
  const srcArr = page.sections[src.path.sectionIndex].contents;
  const tgtArr = page.sections[tgt.path.sectionIndex].contents;

  const [movingContainer] = srcArr.splice(src.path.containerIndex, 1);

  tgtArr.splice(tgt.path.containerIndex, 0, movingContainer);
}
